import { render } from "./MobCreatedForYou.vue?vue&type=template&id=eb476104&scoped=true"
import script from "./MobCreatedForYou.vue?vue&type=script&lang=js"
export * from "./MobCreatedForYou.vue?vue&type=script&lang=js"

import "./MobCreatedForYou.vue?vue&type=style&index=0&id=eb476104&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb476104"]])

export default __exports__